@if(rows?.length)
{
    <div class="popup-details-container">
        <div class="popup-title">{{title | translate}}</div>
        <div class="row popup-details-row col-sm-12">
            @for(row of rows; track row.label){
                <span class="popup-label col-sm-4">{{row.label}}:</span>
                <span class="popup-value col-sm-8">{{row.value}}</span>
            }
        </div>
    </div>
}
